import { MessageBanner } from "@comparaonline/ui-promotions-message-banner";
import React from "react";

import { useAppContext } from "../../../../../lib/appContext";

export const FixedBanner: React.FC = () => {
  const {
    businessUnitConfig: { fixedBanner }
  } = useAppContext();
  return fixedBanner ? (
    <>
      <br />
      <MessageBanner content={fixedBanner.message} backgroundColor={fixedBanner.backgroundColor} />
    </>
  ) : null;
};
